export const useActionSetDisplayNameAndAvatar = () => {
  const { onPlay, complete } = useAbstractAction(
    'actionSetDisplayNameAndAvatar',
    false
  );

  const route = useRoute();

  const { isNeeded, openWindow, onComplete } =
    useProfileSetAvatarAndDisplayName();

  onComplete(() => {
    complete();
  });

  onPlay(async () => {
    if (isNeeded.value && route.path.indexOf(`/${Sections.Gaming}`) === 0) {
      openWindow();
    } else {
      complete();
    }
  });
};
